import { createAction, props } from '@ngrx/store';
import { StoreDataModel } from '../../models/shared/Auth/IUserData.interface';



export const ChangeUserData = createAction('ChangeUserData' , props<StoreDataModel>());
